/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  Dropdown,
  Menu,
  message,
  Empty,
  notification,
  Button,
  Input,
  Tooltip,
  Typography,
  Popconfirm,
  AutoComplete,
  Tag,
  Select,
  Modal,
} from "antd";
import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  BellFilled,
  GlobalOutlined,
  SearchOutlined,
  EnvironmentOutlined,
  BarcodeOutlined,
  HomeOutlined,
  AppstoreOutlined,
  ScanOutlined,
  QrcodeOutlined,
  CloseOutlined
} from "@ant-design/icons";
import Moment from "react-moment";
// import bell from "../../assests/images/bell.svg"; // Replaced with Ant Design icon for better color control
import clock from "../../assests/images/timerIcon.svg";
import appLogo from "../../assests/images/smcsLogo.svg";
import mobileLogo from "../../assests/images/shree-maruti-logo.svg";
import calender from "../../assests/images/calenderIcon.svg";
import checkMark from "../../assests/images/SVG/check.svg";
import hamIcon from "../../assests/images/maruti/hamburgerIcon.svg";
import mail from "../../assests/images/mail.svg";
import cart from "../../assests/images/cart.svg";
import urls from "../../api/urls";
import API from "../../api";
import { showErrorMessage } from "../../utils";
const { VIEW_NOTIFICATION, GET_CART_DETAILS, GET_SEARCH_AUTOFILL, COMMON_CP_HUB_SEARCH, GET_PINCODE_SERVICE, PINCODE_SEARCH_TRACK } = urls;
import "./style.scss";
import { APIs } from "../../utils/worker";
const { baseURL } = APIs;
import { Link } from "react-router-dom";
import constants from "../../constants/constants";
import search_icon from "../../assests/images/search-icon.svg";
import searchArea from "../../assests/images/search-area.svg";
import trackingSearch from "../../assests/images/tracking-search.svg";
import bulkTrackingIcon from "../../assests/images/builk-tracking.svg";
import hubSelection from "../../assests/images/hub-selection.svg";
import exclationIcon from "../../assests/images/SVG/exclation.svg";

import BulkTrackingModal from "./BulkTrackingModal";
import { useNetworkStatus } from "../../hooks/useNetworkStatus";
import { logout } from "../../utils/authUtils";
import EscalationMatrixView from "../../views/EscalationMatrix";

const AppHeader = ({ showLogo, handleOpenDrawer = () => { } }) => {
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const [isEscalationModalOpen, setIsEscalationModalOpen] = useState(false);
  const navigate = useNavigate();

  // Internet connection strength monitoring
  const networkStatus = useNetworkStatus();

  const [dateToFormat, setdateToFormat] = useState(new Date());
  const [userName, setUserName] = useState();
  const [cartDetails, setCartDetails] = useState(0);
  const [items, setItems] = useState([]);
  const [notificationList, setNotificationList] = useState([]);
  const [trackingNumber, setTrackingNumber] = useState("");
  let eventSource = undefined;

  const [lcrNumber, setLcrNumber] = useState("");

  const [api, contextHolder] = notification.useNotification();
  const [pincodeNumber, setPincodeNumber] = useState("");
  const [searchCpName, setSearchCpName] = useState("");
  const [searchHubName, setSearchHubName] = useState("");
  const [cpOptions, setCpOptions] = useState([]);
  const cpDebounceRef = useRef(null);

  let userinfo = {};
  try {
    const stored = localStorage.getItem("userinfo");
    if (stored && stored !== "undefined") {
      userinfo = JSON.parse(stored);
    }
  } catch (e) {
    console.error("Error parsing userinfo in AppHeader", e);
  }

  const getRole = userinfo?.roles[0]?.replace(/.*_/, "");
  const { ROLES } = constants;
  const { HUB_ADMIN, HO_ADMIN } = ROLES;
  const role = userinfo?.roles[0];

  useEffect(() => {
    //initialize();
  }, []);

  const getCartDetails = async () => {
    let response = await API.Api(GET_CART_DETAILS).getWithUserNPremiseHeader();
    if (response.status) {
      localStorage.setItem(
        "cartDetails",
        JSON.stringify(response?.response?.data?.items.length)
      );
      setCartDetails(response?.response?.data?.items.length);
    }
  };
  let userid = {};
  try {
    const storedId = localStorage.getItem("userId");
    if (storedId && storedId !== "undefined") {
      userid = JSON.parse(storedId);
    }
  } catch (e) {
    console.error("Error parsing userId in AppHeader", e);
  }
  let item0List = [
    {
      label: (
        <div className="space-between">
          <span className="fw-600">Notifications</span>
          <img src={mail} />
        </div>
      ),
      key: "0",
    },
    { type: "divider" },
  ];

  const viewAllNotification = (data) => {
    let tempId = [];
    data.map((item) => !item.viewed && tempId.push(item.notificationId));
    viewNotification(tempId, tempId.length > 0 ? false : true);
  };

  const initialize = async () => {
    eventSource = new EventSource(
      `${baseURL}/notification-service/v1/stream-flux/${userid?.userInfo?.userId}`
    );

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setNotificationList(data);
      data.sort(
        (a, b) =>
          a.viewed.toString().charCodeAt(0) - b.viewed.toString().charCodeAt(0)
      );
      let item = [];
      let item1 = {};
      if (data.length > 0) {
        data.map((e, i) => {
          if (i < 4) {
            item.push(
              {
                label: (
                  <div
                    onClick={() =>
                      viewNotification([e.notificationId], e.viewed)
                    }
                  >
                    <span
                      style={{ color: "#202124" }}
                      className="space-between align-center"
                    >
                      <span>{e.notificationTitle}</span>

                      <span
                        className="notifiaction-viewed"
                        style={{
                          background: e.viewed ? "#D2D2D2" : "#EC3E3E",
                        }}
                      ></span>
                    </span>
                    <span style={{ marginTop: "-1rem", color: "#878787" }}>
                      {e.notificationCreatedDate}
                    </span>
                  </div>
                ),
                key: e.id,
              },
              { type: "divider" }
            );
          }
        });
        item1 = {
          label: (
            <span
              className="center"
              style={{ color: "#2E77D0" }}
              onClick={() => viewAllNotification(data)}
            >
              View all Notifications
            </span>
          ),
          key: "notification",
        };
      } else {
        item.push({ label: <Empty />, key: "empty" });
      }

      setItems([...item0List, ...item, item1]);
    };
    eventSource.onerror = (err) => {
      eventSource.close();
    };

    //}
  };

  const viewNotification = async (id, viewed) => {
    if (viewed) {
      navigate("/notification");
    } else {
      let response = await API.Api(VIEW_NOTIFICATION).putIdHeader({
        notificationId: id,
      });
      if (response?.status) {
        navigate("/notification", { state: id });
      } else {
        showErrorMessage("Network error.");
      }
    }
  };

  const profileDetails = useSelector(
    (state) => state.masterReducer.getProfileDetailsReducer,
    shallowEqual
  );
  const { result: profileDetailsResult } = profileDetails;

  useEffect(() => {
    if (profileDetailsResult) {
      setUserName(profileDetailsResult?.data.firstName);
    }
  }, [profileDetailsResult]);

  useEffect(() => {
    let userName = JSON.parse(localStorage.getItem("userName"));
    setUserName(userName);
  }, [localStorage.getItem("userName")]);

  useEffect(() => {
    setInterval(() => {
      let cartDetails = JSON.parse(localStorage.getItem("cartDetails"));
      setCartDetails(cartDetails ? cartDetails : 0);
    }, 1000);
  }, [localStorage.getItem("cartDetails")]);

  useEffect(() => {
    setInterval(() => setdateToFormat(new Date()), 30000);
  }, []);

  const menuClicked = ({ key }) => {
    if (+key === 4) {
      //window.location.assign("/");
      // window.location.replace("/");
      localStorage.clear();
      sessionStorage.clear();
      document.cookie = "userToken=";
      window.location.href = constants.LOGOUT_REDIRECT_URL;
      logout();
    }
    if (+key === 2) {
      navigate("/profile");
    }
  };

  const menu = (
    <Menu
      className="nav-dropdown-a"
      onClick={menuClicked}
      items={[
        {
          label: userName,
          key: "1",
          style: { fontSize: "14px" },
        },
        {
          type: "divider",
        },
        {
          label: "Profile",
          key: "2",
          style: { fontSize: "14px" },
          icon: <UserOutlined />,
          disabled: false,
        },
        {
          label: "Settings",
          key: "3",
          style: { fontSize: "14px" },
          icon: <SettingOutlined />,
          disabled: true,
        },
        {
          label: "Logout",
          key: "4",
          style: { fontSize: "14px" },
          icon: <LogoutOutlined />,
        },
      ]}
    />
  );

  function MyComponent() {
    const toUpperCaseFilter = (d) => {
      return d.slice(0, 15);
    };
    return <Moment filter={toUpperCaseFilter}>{dateToFormat}</Moment>;
  }

  let time = dateToFormat.toLocaleString("en-US", {
    hour: "numeric",
    hour12: true,
    minute: "numeric",
  });

  const openNotification = (placement) => {
    api.info({
      message: <span style={{ color: "red" }}>Extend E-way validity</span>,
      description: (
        <span>
          E-way Bill validity extension is pending. Please{" "}
          <Link to="/extend-eway">click here</Link> to extend..
        </span>
      ),
      placement,
      duration: 0,
      onClick: () => {
        notification.destroy();
      },
    });
  };
  const now = new Date();

  // useEffect(() => {

  const [isNotificationTriggered, setIsNotificationTriggered] = useState(false);

  const triggerNotification = () => {
    const now = new Date();
    const fourPm = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      16,
      0,
      0
    );
    const twelveAm = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0
    );
    const isNotificationAlreadyTriggered = localStorage.getItem(
      "isNotificationTriggered"
    );
    if (userinfo.roles.includes("ROLE_HUBADMIN")) {
      if (
        (now >= fourPm || now <= twelveAm) &&
        !isNotificationTriggered &&
        !isNotificationAlreadyTriggered
      ) {
        openNotification("top");
        setIsNotificationTriggered(true);
        localStorage.setItem("isNotificationTriggered", true);
      }
    }
  };
  useEffect(() => {
    sessionOut();
  }, [userinfo.accessToken, isNotificationTriggered]);

  const sessionOut = () => {
    setInterval(() => {
      triggerNotification();
    }, 1000);
  };


  const routeToTrackingforAwb = (e) => {
    console.log("tracttype......" + trackingNumber);

    if (e == "awb") {
      if (trackingNumber == "") {
        showErrorMessage("Invalid tracking number");
        return;
      }
      const storedPattern = localStorage.getItem("regexPattern");
      //console.log("Stored regexPattern:", storedPattern);
      /*if (!storedPattern) {
        showErrorMessage("Tracking pattern not configured");
        return;
      }*/

      // Remove extra slashes from the stored pattern
      const cleanPattern = storedPattern?.replace(/^\/|\/$/g, "");
      const regex = new RegExp(cleanPattern);
      // Check regex with original tracking number
      if (regex.test(trackingNumber)) {
        // If tracking number contains forward slash, replace it with plus sign
        const finalTrackingNumber = trackingNumber;

        navigate("/shipment-tracker", {
          state: { awb: finalTrackingNumber, num: Math.random() },
        });
        setTrackingNumber("");
      } else {
        showErrorMessage("Invalid tracking number",);
      }
    } else {
      let track = lcrNumber.replace(/\s+/g, "");
      if (track.length >= 10) {
        let a = track;
        setLcrNumber("");
        navigate("/lcr-report", {
          state: { vehicle_lcr_id: a, lcr_num: a, tracking: true },
        });
      } else {
        showErrorMessage("Invalid lcr number",);
        //showMessage();
        // message.error("Invalid tracking number", 20);
      }
    }
  };

  const handleInputChangeforAwb = (value) => {
    if (value.replace(/[~`^+=@#$%&*!()]/g, "") !== value) return;
    setTrackingNumber(value);

  };
  const handleInputChangeForLcr = (value) => {
    if (!isNaN(value)) {
      setLcrNumber(value);
    }
  };

  const handleInputChangeForPincode = (value) => {
    // Allow only numeric values for pincode (typically 6 digits)
    if (!isNaN(value) && value.length <= 6) {
      setPincodeNumber(value);
    }
  };

  const fetchCpSuggestions = async (term) => {
    const query = term.trim();
    if (query.length < 2) {
      setCpOptions([]);
      return;
    }
    try {
      const response = await API.Api(`${GET_SEARCH_AUTOFILL}?name=${encodeURIComponent(query)}`).getWithUserNPremiseHeader();
      if (response.status) {
        const data = response.response?.data || [];
        const options = (Array.isArray(data) ? data : []).map((name) => ({ value: String(name) }));
        setCpOptions(options);
      } else {
        setCpOptions([]);
      }
    } catch (err) {
      setCpOptions([]);
    }
  };

  const handleInputChangeForCpName = (value) => {
    // Allow letters, numbers, spaces, hyphens, apostrophes, dots, and ampersands
    const stringOnlyPattern = /^[a-zA-Z0-9\s\-'.&]*$/;
    if (stringOnlyPattern.test(value)) {
      setSearchCpName(value);
      if (cpDebounceRef.current) clearTimeout(cpDebounceRef.current);
      cpDebounceRef.current = setTimeout(() => fetchCpSuggestions(value), 300);
    }
  };

  const handleSelectCpSuggestion = (val) => {
    setSearchCpName(val);
  };
  const routeToTrackingforPincode = async () => {
    let pincode = pincodeNumber.replace(/\s+/g, "");
    if (pincode.length === 6) {
      try {
        let response = await API.Api(`${PINCODE_SEARCH_TRACK}?pincode=${pincode}`).getWithUserNPremiseHeaderPincode();
        if (response.status && response.response?.data) {
          const responseData = response.response?.data;
          const serviceDetails = responseData?.data?.serviceDetails;

          // Check if data is not empty
          if (!serviceDetails || (Array.isArray(serviceDetails) && serviceDetails.length === 0)) {
            showErrorMessage(`No details found for pincode "${pincode}". This pincode may not be serviceable.`);
            return;
          }

          setPincodeNumber("");
          // Navigate to pincode search results page with API response data
          navigate("/pincode-search", {
            state: {
              pincode: pincode,
              pincodeData: response.response?.data,
              tracking: true
            },
          });
        } else {
          showErrorMessage(`Pincode "${pincode}" not found or invalid. Please verify the pincode and try again.`);
        }
      } catch (error) {
        console.error("Pincode API error:", error);
        showErrorMessage(`Unable to fetch details for pincode "${pincode}". Please check your connection and try again.`);
      }
    } else {
      showErrorMessage("Invalid pincode format. Please enter exactly 6 digits.");
    }
  };

  const searchCpOrName = async () => {
    let searchTerm = searchCpName.trim();
    if (searchTerm.length >= 2) {
      try {
        let response = await API.Api(`${COMMON_CP_HUB_SEARCH}?name=${searchTerm}`).getWithUserNPremiseHeader();
        if (response.status && response.response?.data) {
          // Check if data is not empty
          if (Array.isArray(response.response.data) && response.response.data.length === 0) {
            showErrorMessage(`No CP details found for "${searchTerm}". Please try with different search term.`);
            return;
          }
          if (!Array.isArray(response.response.data) && Object.keys(response.response.data).length === 0) {
            showErrorMessage(`No CP details found for "${searchTerm}". Please try with different search term.`);
            return;
          }

          setSearchCpName("");
          setCpOptions([]);
          // Navigate to CP search results page with API response data
          if (searchTerm.includes("HUB")) {
            navigate("/hub-search", {
              state: {
                searchTerm: searchTerm,
                hubData: response.response?.data,
                searchType: "hub_name",
                tracking: true
              },
            });
          } else {
            navigate("/cp-search", {
              state: {
                searchTerm: searchTerm,
                cpData: response.response?.data,
                searchType: "cp_name",
                tracking: true
              },
            });
          }
        }
      } catch (error) {
        console.error("CP API error:", error);
        showErrorMessage(`Unable to fetch CP details for "${searchTerm}". Please check your connection and try again.`);
      }
    } else {
      showErrorMessage("Please enter CP name for search.");
    }
  };

  const getStatusInfo = () => {
    const { connectionStrength, isOnline } = networkStatus;
    if (!isOnline || connectionStrength === "offline") {
      return { status: "Offline", color: "#ff4d4f" };
    }
    if (["excellent", "good"].includes(connectionStrength)) {
      return { status: "Good", color: "#00b96b" }; // Green
    }
    return { status: "Weak", color: "#faad14" }; // Yellow/Orange
  };

  const statusInfo = getStatusInfo();

  return (
    <div className="header-new-container">
      {contextHolder}

      {/* 1. Logo Section */}
      <div className="header-logo-section">
        {/* <img
            src={hamIcon}
            className="mr-1 ham-mobile"
            onClick={handleOpenDrawer}
          /> */}
        <div className="banner">
          <img src={appLogo} className="web-logo" alt="Shree Maruti" />
          <img src={mobileLogo} className="mobile-logo" alt="Shree Maruti" />
        </div>
      </div>

      {/* 2. Middle Section - Search & Actions */}
      <div className="header-search-section">
        <TrackingComponent
          trackingNumber={lcrNumber}
          handleInputChange={(e) => handleInputChangeForLcr(e)}
          routeToTracking={() => routeToTrackingforAwb("lcr")}
          placeholder="Enter LCR ID"
          icon={<img src={searchArea} alt="search" />}
        />

        {<TrackingComponent
          trackingNumber={pincodeNumber}
          handleInputChange={(e) => handleInputChangeForPincode(e)}
          routeToTracking={routeToTrackingforPincode}
          placeholder="Pincode"
          icon={<img src={searchArea} alt="search" />}
        />}

        <TrackingComponent
          trackingNumber={searchCpName}
          handleInputChange={(e) => handleInputChangeForCpName(e)}
          routeToTracking={searchCpOrName}
          placeholder="CP/Hub"
          useAutoComplete={true}
          autoCompleteOptions={cpOptions}
          onSelectOption={handleSelectCpSuggestion}
          icon={<img src={searchArea} alt="search"></img>}
        />

        <TrackingComponent
          trackingNumber={trackingNumber}
          handleInputChange={(e) => handleInputChangeforAwb(e)}
          routeToTracking={() => routeToTrackingforAwb("awb")}
          placeholder="Tracking ID"
          icon={<img src={trackingSearch} alt="tracking-search" />}
        />

        <div className="search-component-item" style={{ width: "auto" }}>
          <div
            className="custom-header-input bulk-tracking-btn"
            onClick={() => setIsBulkModalOpen(true)}
          >
            <img
              src={bulkTrackingIcon}
              alt="bulk"
              className="bulk-icon"
            />
            <span className="bulk-text">
              Bulk Tracking
            </span>
          </div>
        </div>

        <div className="search-component-item hub-select-container" style={{ position: "relative" }}>
          <HomeOutlined className="hub-home-icon" />
          {(() => {
            const userFullData = JSON.parse(localStorage.getItem("userId"));
            const hubList = userFullData?.userInfo?.hubDetails || [];
            const activeHub = JSON.parse(
              localStorage.getItem("active_hub") || "{}"
            );



            const onHubChange = (value) => {
              const selectedHub = hubList.find((h) => h.hubId === value);
              if (selectedHub) {
                localStorage.setItem(
                  "active_hub",
                  JSON.stringify(selectedHub)
                );
                window.dispatchEvent(new Event("hubChanged"));
              }
            };

            return (
              <Select
                placeholder="Select Hub"
                value={activeHub?.hubId}
                onChange={onHubChange}
                style={{ width: "200px", borderRadius: "6px" }}
                // suffixIcon={<img src={hubSelection} alt="tracking-search" />}
                bordered={false}
                className="custom-select"
              >
                {hubList.map((hub) => (
                  <Select.Option key={hub.hubId} value={hub.hubId}>
                    {hub.hubName}
                  </Select.Option>
                ))}
              </Select>
            );
          })()}
        </div>
      </div>

      {/* 3. Right Section - Profile & Status */}
      <div className="header-right-section">

        {/* Network Status Pill */}
        <Tooltip
          title={
            <div style={{ padding: "4px" }}>
              <div><strong>Status:</strong> {networkStatus.isOnline ? "Online" : "Offline"}</div>
              <div><strong>Strength:</strong> <span style={{ textTransform: "capitalize" }}>{networkStatus.connectionStrength}</span></div>
              {networkStatus.downlink && <div><strong>Speed:</strong> {networkStatus.downlink} Mbps</div>}
              {networkStatus.rtt && <div><strong>Latency:</strong> {networkStatus.rtt} ms</div>}
              {networkStatus.connectionType && <div><strong>Type:</strong> <span style={{ textTransform: "capitalize" }}>{networkStatus.connectionType}</span></div>}
            </div>
          }
          placement="bottom"
        >
          <div className="status-pill">
            <GlobalOutlined style={{ color: statusInfo.color, marginRight: 6 }} />
            <span style={{ color: statusInfo.color, fontWeight: 600 }}>{statusInfo.status}</span>
          </div>
        </Tooltip>


        {/* Exclamation Icon */}
        <div className="exclation-icon" onClick={() => setIsEscalationModalOpen(true)}>
          <img src={exclationIcon} alt="exclation" style={{ width: "100%", height: "100%" }} />
        </div>

        {/* Notifications */}
        <div className="notification-icon">
          <Dropdown
            menu={{
              items,
            }}
            overlayClassName="nav-dropdown-overlay nav-dropdown-overlay-notification"
          >
            <a onClick={(e) => e.preventDefault()}>
              <BellFilled style={{ fontSize: "20px", color: "#fff" }} />
              {notificationList?.length > 0 &&
                notificationList.some((e) => e.viewed == false) && (
                  <div className="notification-dot"></div>
                )}
            </a>
          </Dropdown>
        </div>

        {/* User Profile */}
        <div className="user-profile">
          <Dropdown overlay={menu} overlayClassName="nav-dropdown-overlay" placement="bottomRight">
            <div className="avatar-circle">
              {userName?.charAt(0).toUpperCase() || "H"}
            </div>
          </Dropdown>
        </div>
      </div>
      {/* Modal Integration */}
      <BulkTrackingModal
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
      />

      <Modal
        title={null}
        open={isEscalationModalOpen}
        onCancel={() => setIsEscalationModalOpen(false)}
        footer={null}
        width={1200}
        bodyStyle={{ padding: "0px", maxHeight: "80vh", overflowY: "auto" }}
        destroyOnClose
        className="escalation-modal"
        closeIcon={<CloseOutlined style={{ fontSize: "24px", color: "#003371", background: "#fff", borderRadius: "50%", padding: "8px", boxShadow: "0 4px 15px rgba(0,0,0,0.3)", position: "absolute", top: "0px", right: "-20px", zIndex: 10002 }} />}
      >
        <EscalationMatrixView />
      </Modal>

    </div>
  );
};
export default AppHeader;

function TrackingComponent({
  trackingNumber,
  handleInputChange,
  routeToTracking,
  placeholder,
  useAutoComplete = false,
  autoCompleteOptions = [],
  onSelectOption = () => { },
  icon = null
}) {
  return (
    <div className="search-component-item">
      {useAutoComplete ? (
        <AutoComplete
          value={trackingNumber}
          options={autoCompleteOptions}
          onSelect={onSelectOption}
          onChange={handleInputChange}
          className="custom-input-wrapper"
          style={{ width: "100%" }}
        >
          <Input
            prefix={<span className="input-icon">{icon}</span>}
            placeholder={placeholder}
            onPressEnter={routeToTracking}
            className="custom-header-input"
            bordered={false}
          />
        </AutoComplete>
      ) : (
        <Input
          prefix={<span className="input-icon">{icon}</span>}
          placeholder={placeholder}
          value={trackingNumber}
          onChange={(e) => handleInputChange(e.target.value)}
          onPressEnter={routeToTracking}
          className="custom-header-input"
          bordered={false}
        />
      )}
    </div>
  );
}
